import { API_PROTOCOL, DOMAIN_WITHOUT_PORT } from 'constants/application_constants';

export const INTERMEDIARY_URL_SEARCH_PARAM = 'intermediary_token';

export const getIntermediaryLoginPath = (token) => (
  `${ API_PROTOCOL }://app.${ DOMAIN_WITHOUT_PORT }?${ INTERMEDIARY_URL_SEARCH_PARAM }=${ token }`
);
